import { render, staticRenderFns } from "./ChoiceResource.vue?vue&type=template&id=3ce8d466"
import script from "./ChoiceResource.vue?vue&type=script&lang=js"
export * from "./ChoiceResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports